import React from "react";
import { Link } from "react-router-dom";


// ---------------------------------------------------------------------------
// PERMISSION KEYS  (module-level — one key per main section)
// ---------------------------------------------------------------------------
// campaigns        → Campaigns + Quick Campaign
// blog_posts       → Blog Posts
// fb_campaigns     → FB Campaigns
// url_mapping      → URL Mapping + Tools
// pre_landers      → Pre-Landers (sub + dynamic)
// page_mapping     → Pages AdManager Mapping
// int_rsoc         → INT RSOC Campaigns
// obm_campaigns    → OB Media Campaigns
// direct_campaigns → Direct Campaigns
// spine_campaigns  → Spine Campaigns
// users            → User Management
// buying_strategy  → Buying Strategy
// roles_permissions→ Roles, Permissions, Assign
// redirect_domains → Redirect Domains
// settings         → App Settings + all config
// audit_logs       → Audit Logs + Redirect Error Logs
// ---------------------------------------------------------------------------

const Sidebar = () => {
  const LogOut = (e) => {
    e.preventDefault();
    const preUrl = window.location.pathname;
    window.localStorage.removeItem("laravel-token");
    window.localStorage.setItem("last-active-page", preUrl);
    window.location.href = "../login";
  };

  let userPermissions = window.localStorage.getItem("user-permissions");
  let P = userPermissions
    ? userPermissions.split(",")
    : (window.location.href = "../login");

  // Helper — readable alias
  const can = (key) => P.includes(key);

  return (
    <>
      <nav className="main-nav" id="sidenavAccordion">
        <div className="upper">

          {/* ── Dashboard ──────────────────────────────────────────── */}
          <Link className="nav-link nav-link--dashboard" to="/dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:"6px",verticalAlign:"middle"}}>
              <rect x="3" y="3" width="7" height="7"/>
              <rect x="14" y="3" width="7" height="7"/>
              <rect x="14" y="14" width="7" height="7"/>
              <rect x="3" y="14" width="7" height="7"/>
            </svg>
            Dashboard
          </Link>

          {/* ── Campaigns ──────────────────────────────────────────── */}
          {can("campaigns") && (
            <>
              <div className="nav-combo">
                <Link className="nav-link" to="/campaign_listing">
                  Campaigns
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/campaign_create"
                >
                  <PlusIcon />
                </Link>
              </div>
              <div className="nav-combo">
                <Link className="nav-link" to="/quick_campaign">
                  Quick Campaign
                </Link>
              </div>
              <div className="nav-combo">
                <Link className="nav-link" to="/agent_studio">
                  Agent Studio
                </Link>
              </div>
            </>
          )}

          {/* ── Blog Posts ─────────────────────────────────────────── */}
          {can("blog_posts") && (
            <div className="nav-combo">
              <Link className="nav-link" to="/blog_posts">
                Blog Posts
              </Link>
              <Link
                className="btn btn-icon btn-icon-sm"
                title="Create New"
                to="/create_blog_post"
              >
                <PlusIcon />
              </Link>
            </div>
          )}

          {/* ── FB Campaigns ───────────────────────────────────────── */}
          {can("fb_campaigns") && (
            <Link className="nav-link" to="/fb_campaign_list">
              FB Campaigns
            </Link>
          )}

          {/* ── URL Mapping ────────────────────────────────────────── */}
          {can("url_mapping") && (
            <>
              <Link className="nav-link" to="/listing_url_mapping">
                URL Mapping
              </Link>
              <Link
                className="nav-link"
                to="/url_mapping_tools"
                style={{ paddingLeft: "25px", fontSize: "13px", opacity: 0.85 }}
              >
                ↳ URL Mapping Tools
              </Link>
              <Link
                className="nav-link"
                to="/url_winner_analysis"
                style={{ paddingLeft: "25px", fontSize: "13px", opacity: 0.85 }}
              >
                ↳ Winner Analysis
              </Link>
            </>
          )}

          {/* ── Pre-Landers ────────────────────────────────────────── */}
          {can("pre_landers") && (
            <Link className="nav-link" to="/listing_pre_lander">
              Pre-Lander's
            </Link>
          )}

          {/* ── Pages Mapping ──────────────────────────────────────── */}
          {can("page_mapping") && (
            <div className="nav-group">
              <div className="nav-title">Pages Mapping</div>
              <div className="nav-combo">
                <Link
                  className="nav-link"
                  to="/pages_admanager_mapping_listing"
                >
                  Overview
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_pages_admanager_mapping"
                >
                  <PlusIcon />
                </Link>
              </div>
            </div>
          )}

          {/* ── Users ──────────────────────────────────────────────── */}
          {can("users") && (
            <div className="nav-combo">
              <Link className="nav-link" to="/listing_users">
                Users
              </Link>
              <Link
                className="btn btn-icon btn-icon-sm"
                title="Create New"
                to="/create_users"
              >
                <PlusIcon />
              </Link>
            </div>
          )}

          {/* ── Buying Strategy ────────────────────────────────────── */}
          {can("buying_strategy") && (
            <div className="nav-combo">
              <Link className="nav-link" to="/buying_strategy_listing">
                Buying Strategy
              </Link>
              <Link
                className="btn btn-icon btn-icon-sm"
                title="Create New"
                to="/create_buying_strategy"
              >
                <PlusIcon />
              </Link>
            </div>
          )}

          {/* ── Roles & Permissions ────────────────────────────────── */}
          {can("roles_permissions") && (
            <div className="nav-group">
              <div className="nav-title">Roles & Permission</div>
              <div className="nav-combo">
                <Link className="nav-link" to="/roles_listing">
                  Roles
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/save_roles"
                >
                  <PlusIcon />
                </Link>
              </div>
              <div className="nav-combo">
                <Link className="nav-link" to="/permissions_listing">
                  Permissions
                </Link>
              </div>
              <Link className="nav-link" to="/role_permissions_add">
                Assign Permission
              </Link>
            </div>
          )}

          {/* ── Settings ───────────────────────────────────────────── */}
          {can("settings") && (
            <div className="nav-group">
              <div className="nav-title">Settings</div>

              <Link className="nav-link" to="/create_dynamic_campaign_name">
                Dynamic Campaign Name
              </Link>

              <Link className="nav-link" to="/worth_pause_distinct">
                Worth Pause Campaign
              </Link>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_category">
                  Categories
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_category"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_audience">
                  Audience
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_audience"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_conversion_event">
                  Conversion Event
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_conversion_event"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_domain_setting">
                  Domain Setting
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_domain_setting"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_url_mapping_params">
                  URL Mapping Params
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_url_mapping_params"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_params_mapping">
                  Params Mapping
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_params_mapping"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_fb_default_params">
                  FB Default Params
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_fb_default_params"
                >
                  <PlusIcon />
                </Link>
              </div>

            </div>
          )}

          {/* ── Redirect Domains ───────────────────────────────────── */}
          {can("redirect_domains") && (
            <div className="nav-group">
              <div className="nav-title">Redirect</div>
              <div className="nav-combo">
                <Link className="nav-link" to="/listing_redirect_domains">
                  Redirect Domains
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_redirect_domains"
                >
                  <PlusIcon />
                </Link>
              </div>
            </div>
          )}

          {/* ── Config (always available to settings) ──────────────── */}
          {can("settings") && (
            <>
              <div className="nav-combo">
                <Link className="nav-link" to="/listing_country">
                  Countries
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_country"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_language">
                  Languages
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_language"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_adsense_style">
                  Adsense Styles
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_adsense_style"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_setting">
                  App Setting
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_setting"
                >
                  <PlusIcon />
                </Link>
              </div>

              <div className="nav-combo">
                <Link className="nav-link" to="/listing_rewrite_prompts">
                  Rewrite Prompts
                </Link>
                <Link
                  className="btn btn-icon btn-icon-sm"
                  title="Create New"
                  to="/create_rewrite_prompt"
                >
                  <PlusIcon />
                </Link>
              </div>
            </>
          )}

          {/* ── Audit Logs ─────────────────────────────────────────── */}
          {can("audit_logs") && (
            <div className="nav-group">
              <div className="nav-title">Logs</div>
              <Link className="nav-link" to="/audit_logs">
                Audit Logs
              </Link>
              <Link className="nav-link" to="/redirect_error_logs">
                Redirect Error Logs
              </Link>
            </div>
          )}

        </div>

        {/* ── Log out ──────────────────────────────────────────────── */}
        <div className="lower">
          <Link className="nav-link" to="/#" onClick={LogOut}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
              <path d="M9 12h12l-3 -3" />
              <path d="M18 15l3 -3" />
            </svg>
            <span>Log-out</span>
          </Link>
        </div>
      </nav>
    </>
  );
};

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M9 12h6" />
    <path d="M12 9v6" />
  </svg>
);

export default Sidebar;
